// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";

function getWayPointsAttributes(placeOrderData) {
  var wayPointList_0 = placeOrderData.wayPointOne;
  var wayPointList_1 = {
    hd: placeOrderData.wayPointTwo,
    tl: {
      hd: placeOrderData.wayPointThree,
      tl: /* [] */0
    }
  };
  var wayPointList = {
    hd: wayPointList_0,
    tl: wayPointList_1
  };
  var filteredList = List.filter(function (e) {
          return e.showForm;
        })(wayPointList);
  var optionalLatLng = List.map((function (e) {
          return e.address.latLng;
        }), filteredList);
  var filteredOptionalArray = Belt_List.toArray(Belt_List.keepMap(optionalLatLng, (function (e) {
              return e;
            })));
  return $$Array.map((function (e) {
                return {
                        lat: e.lat,
                        long: e.lng
                      };
              }), filteredOptionalArray);
}

function getData(coupon_code, placeOrderData, vehicle_ids) {
  var customerInfo = placeOrderData.customerInfo;
  var dropAddress = placeOrderData.dropAddress;
  var pickupAddress = placeOrderData.pickupAddress;
  var geo = placeOrderData.geo_region;
  var latLng = pickupAddress.latLng;
  var latLng$1 = pickupAddress.latLng;
  var latLng$2 = dropAddress.latLng;
  var latLng$3 = dropAddress.latLng;
  return {
          mobile: customerInfo.mobile,
          coupon_code: coupon_code,
          n_waypoints: 0,
          vehicle_ids: vehicle_ids,
          order: {
            customer_mobile: customerInfo.mobile,
            geo_region_id: geo !== undefined ? geo.id : -1,
            from_address_lat: latLng !== undefined ? latLng.lat : 0.0,
            from_address_long: latLng$1 !== undefined ? latLng$1.lng : 0.0,
            to_address_lat: latLng$2 !== undefined ? latLng$2.lat : 0.0,
            to_address_long: latLng$3 !== undefined ? latLng$3.lng : 0.0,
            waypoints_attributes: getWayPointsAttributes(placeOrderData),
            value_added_services: [],
            payment_mode: "cash",
            business_order_info: undefined,
            use_porter_credits: false
          },
          service_type: undefined
        };
}

export {
  getWayPointsAttributes ,
  getData ,
  
}
/* No side effect */
